import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["oppositeSelect", "amountInput"]

  updateAmount() {
    const option = this.oppositeSelectTarget.selectedOptions[0]
    if (!option) return
    const defaultAmount = option.dataset.defaultAmount
    if (defaultAmount !== undefined) this.amountInputTarget.value = defaultAmount
  }
}
